<template>
    <div>
        <loading-container v-if="loading"></loading-container>

        <div v-else class="container">
            <div class="panel panel-default">
                <div class="panel-body">
                    <table class="table table-condensed table-striped">
                        <thead>
                        <tr>
                            <th class="col-xs-1 text-center">
                                <input type="checkbox" :disabled="true">
                            </th>

                            <th class="col-xs-11">
                                Name
                            </th>

                            <th class="col-xs-11">
                                Price
                            </th>

                            <th class="col-xs-1"></th>
                        </tr>
                        </thead>

                        <tbody>
                        <tr v-for="subscriptionType in subscriptionTypes">
                            <td class="text-center">
                                <input type="checkbox" :disabled="true">
                            </td>

                            <td>
                                <router-link :to="getLink(subscriptionType)">
                                    {{ subscriptionType.attributes.name }}
                                </router-link>
                            </td>

                            <td>
                                {{ subscriptionType.attributes.price | price }}
                            </td>

                            <td class="text-right">
                                <div class="btn-group list-actions">
                                    <router-link :to="getLink(subscriptionType)" class="btn btn-sm">
                                        <i class="fa fa-search"></i>
                                    </router-link>

                                    <button type="button" class="btn btn-sm" @click="destroy(subscriptionType)">
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>

                        <tr v-if="!subscriptionTypes.length">
                            <td colspan="3" class="text-center">
                                <i>
                                    There are no subscription types to display.
                                </i>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import http from '@/http'
import LoadingContainer from '@/components/Layout/LoadingContainer'

export default {
    components: {LoadingContainer},

    model: {
        prop: 'portal',
        event: 'portal-updated'
    },

    props: ['portal'],

    data() {
        return {
            subscriptionTypes: null,

            loading :true
        }
    },

    mounted() {
        this.load()
    },

    methods: {
        load() {
            http.get('/api/v2/subscription-types', {'filter[portal_id]': this.portal.id}).then(response => {
                this.subscriptionTypes = response.data.data

                this.loading = false
            })
        },

        getLink(subscriptionType) {
            return '/portals/' + this.portal.id + '/subscription-types/' + subscriptionType.id
        }
    }
}
</script>
